<ng-container *ngIf="showReporterButtons">
  <div class="container simple mobile card-shadow" *ngIf="onHomeNewsPage === false && showMobileCard">
    <div class="row">
      <img class="trumpet-icon" src="assets/icons/fan.at/megaphone.svg" alt="Trumpet Icon"/>
    </div>

    <h3>Mehr News schreiben</h3>

    <p *ngIf="userIsNewsReporter">Du bist Reporter - halte die Fans am Laufenden!</p>
    <p *ngIf="!userIsNewsReporter">Du bist Reporter deines Teams - halte deine Fans am Laufenden!</p>

    <div class="button-wrapper">
      <button mat-stroked-button (click)="openNewsReporterWebsite()">
        <mat-icon>mic</mat-icon>
        Berichte über dein Team
      </button>
    </div>
  </div>

  <a class="container simple desktop card-shadow" [href]="linkToReporter" appClearHref target="_blank">
    <div class="profile-row">
      <div class="img-col">
        <img src="assets/icons/person.svg" alt="profile image">
      </div>
      <div class="text-col">
        <span class="bold">News schreiben</span>
        <span *ngIf="userIsNewsReporter">Du bist Reporter - halte die Fans am Laufenden!</span>
        <span *ngIf="!userIsNewsReporter">Du bist Reporter des Teams - halte deine Fans am Laufenden!</span>
      </div>
    </div>

    <div class="input-row">
      <span *ngIf="userIsNewsReporter">Was gibt’s Neues?</span>
      <span *ngIf="!userIsNewsReporter">Was gibt’s Neues beim {{ nameOfTeam }}?</span>
    </div>
  </a>
</ng-container>
